
import { Roles } from "@/api";
import { Permission, Role, RoleUser } from "@/api/types";
import PageTitle from "@/components/common/PageTitle.vue";
import RolePermissionsList from "@/components/settings/RolePermissionsList.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    PageTitle,
    RolePermissionsList
  }
})
export default class EditUserRolesPage extends Vue {
  headersTitle = [{ icon: "mdi-account-lock", header: "Edit Role" }];
  buttonsArray = [
    {
      text: "Back to list",
      icon: "",
      color: "gray",
      action: "back"
    }
  ];
  role: Role = {
    name: "",
    id: 0
  };
  permissions: Array<Permission> = [];
  selectedPermissions: Array<number> = [];
  userSearch: string | null = "";
  get roleId() {
    return this.$route.params.id;
  }
  get roleUsers(): Array<RoleUser> {
    return this.role.users || [];
  }
  get filteredRoleUsers(): Array<RoleUser> {
    const search = (this.userSearch || "").trim().toLowerCase();
    if (!search) {
      return this.roleUsers;
    }
    return this.roleUsers.filter(
      (user: RoleUser) =>
        user.name.toLowerCase().includes(search) ||
        user.email.toLowerCase().includes(search)
    );
  }
  async created() {
    try {
      [this.role, this.permissions] = await Promise.all([
        Roles.info(this.$route.params.id),
        Roles.permissions()
      ]);
      this.selectedPermissions = this.role.permissions
        ? this.role.permissions.map((item: Permission) => item.id)
        : [];
    } catch (e) {
      await this.$error(e.errors);
    }
  }
  async save() {
    try {
      await Roles.update(this.roleId, {
        name: this.role.name,
        permissions: this.selectedPermissions
      });
      await this.$success("<strong>Success!</strong> Role has been updated!");
    } catch (e) {
      (this.$refs.roleForm as Vue & {
        setErrors: (errors: any) => void;
      }).setErrors(e.errors);
      await this.$error(e.errors);
    }
  }
}
